import { useIntl } from 'react-intl'

import SearchSvg from 'assets/svg/search.svg?react'
import Cross from 'assets/svg/close.svg?react'

import { TextInput, Icon, Clear, LightInput } from './styled'

import translations from './translations'

function Search({
  value,
  onChange,
  placeholder: placeholderIntl = translations.placeholder,
  className,
  size,
  left = <Icon component={SearchSvg} />,
  right,
  innerLeftWidth,
  outerRightWidth,
  onKeyDown,
  disabled,
  dataTestId = 'input_search',
}) {
  const { formatMessage } = useIntl()
  const placeholder = formatMessage(placeholderIntl)

  return (
    <TextInput
      dataTestId={dataTestId}
      className={className}
      name="hb-search"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      autoComplete="off"
      size={size}
      left={left}
      right={
        right ||
        (value.length >= 1 && <Clear dataTestId="cross_clear" onClick={() => onChange('')} component={Cross} />)
      }
      innerLeftWidth={innerLeftWidth}
      outerRightWidth={outerRightWidth}
      onKeyDown={onKeyDown}
      disabled={disabled}
    />
  )
}

function LightSearch({
  value,
  onChange,
  placeholder: placeholderIntl = translations.placeholder,
  className,
  maxLength,
  onMouseDown,
  onTouchStart,
  onFocus,
  onBlur,
  size = 'regular',
  fillSpace = false,
  dataTestId = 'input_search',
  ...props
}) {
  const { formatMessage } = useIntl()
  const placeholder = formatMessage(placeholderIntl)

  const fieldId = 'hb-search-light'
  function handleFocus(e) {
    e.target.placeholder = ''
    onFocus && onFocus(e)
  }

  function handleBlur(e) {
    e.target.placeholder = placeholder
    onBlur && onBlur(e)
  }

  function onClear() {
    onChange('')
    if (props.autoFocus) {
      document.getElementById(fieldId)?.focus()
    }
  }

  return (
    <LightInput className={className} size={size}>
      <LightInput.Icon component={SearchSvg} size={size} />
      <LightInput.Wrapper size={size} fillSpace={fillSpace}>
        <LightInput.Field
          data-testid={dataTestId}
          id={fieldId}
          name={fieldId}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={handleFocus}
          onBlur={handleBlur}
          maxLength={maxLength}
          autoComplete="off"
          onMouseDown={onMouseDown}
          onTouchStart={onTouchStart}
          size={size}
          {...props}
        />
        <LightInput.Text size={size}>{value.length > 0 ? value : placeholder}</LightInput.Text>
      </LightInput.Wrapper>
      {value.length >= 1 && (
        <LightInput.Clear
          onClick={onClear}
          component={Cross}
          dataTestId="cross_clear"
          size={size}
          fillSpace={fillSpace}
        />
      )}
    </LightInput>
  )
}

Search.Light = LightSearch

export default Search
